import { authHeader } from '../_helpers';
import { getCookie } from '../_helpers/cookie';
import axios from 'axios';
export const userService = {
    login,
    userSession,
    logout,
    register,
    getAll,
    getById,
    update,
    addAddress,
    forgot_password,
    delete: _delete,
    getAuthToken
};

// Helper function to get auth token from localStorage or cookie
function getAuthToken() {
    const localToken = localStorage.getItem("userToken");
    const cookieToken = getCookie("authToken");
    
   // console.log('getAuthToken - localStorage:', !!localToken, 'cookie:', !!cookieToken);
    
    return localToken || cookieToken;
}

async function login(userdata) {
    try 
    {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email:userdata.email,password: userdata.password })
        };

        const response = await fetch(process.env.REACT_APP_API_URL+`api/login`, requestOptions);
        //console.log('user-successdddd handleResponse',response);
        const user = await handleResponse(response);
        
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        if(user.sucess == true)
        {
            const expiryDate = new Date();
            expiryDate.setDate(expiryDate.getDate() + 7); 
            document.cookie = `authToken=${user.token}; path=/; domain=${process.env.REACT_APP_SUB_DOMAIN}; expires=${expiryDate.toUTCString()}; secure; SameSite=None`;
            localStorage.setItem("userToken", user.token);
           // console.log('user.data handleResponse',user.data);
            if(user.data.accounttype!==null && user.data.accounttype.split(',').includes("professional"))
            {
               // console.log('user.data pro',process.env.REACT_APP_PRO_WEB_URL,user.data);
                localStorage.setItem("user_pro", JSON.stringify(user));
                const redirectUrl = new URL(process.env.REACT_APP_PRO_WEB_URL);
                redirectUrl.searchParams.set('token', user.token);
                redirectUrl.searchParams.set('userId', user.data.id);
                redirectUrl.searchParams.set('email', user.data.email);
                window.location.href = redirectUrl.toString();
            }
            else
            {
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem('id', user.data.id);
                localStorage.setItem('email', user.data.email);
                localStorage.setItem('is_login', 'true');
            }
            
        }
        if(userdata.remember_password === true)
        {
            localStorage.setItem('remember_email', userdata.email);
            localStorage.setItem('remember_password', userdata.password);
            localStorage.setItem('is_remember', userdata.remember_password);
        }
        else
        {
            localStorage.removeItem('remember_email');
            localStorage.removeItem('remember_password');
            localStorage.removeItem('is_remember');
        }
        //console.log('user-dfdfgdfgdfg',user);
        return user;
    } 
    catch (error) 
    {
        return error;
    }
}

function logout() {
    // remove user from local storage to log user out
    const keysToRemove = ["user", "user_pro", "email", "id", "userToken", "is_login", "announceCurrentUrl"];
    keysToRemove.forEach((key) => {
        localStorage.removeItem(key);
    });
    
    // Clear the authentication cookie
    document.cookie = `authToken=; path=/; domain=${process.env.REACT_APP_SUB_DOMAIN}; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; SameSite=None`;
}

async function getAll() {
    try 
    {
        const requestOptions = {
            method: 'GET',
            headers: authHeader()
        };

        const response = await fetch(`/users`, requestOptions);
    return handleResponse(response);
    } 
    catch (error) 
    {
        return error;
    }
}

async function getById(id) {
    try 
    {
        const requestOptions = {
        method: 'GET',      
        headers: authHeader()   
    };

    const response = await fetch(`/users/${id}`, requestOptions);
    return handleResponse(response);
    } 
    catch (error) 
    {
        return error;
    }
}

async function addAddress(formData) {
    try 
    {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    };

    const response = await fetch(process.env.REACT_APP_API_URL+`api/user_address`, requestOptions);    
    const get_user_address = await handleResponse(response);
    // store user details and jwt token in local storage to keep user logged in between page refreshes
    if(get_user_address.sucess === true){
        let userData = localStorage.getItem('user');
        let userDataParse = JSON.parse(userData);
        userDataParse.user_address = get_user_address.user_address;
        localStorage.setItem('user', JSON.stringify(userDataParse));
    }
   
    return get_user_address;
    } 
    catch (error) 
    {
        return error;
    }
}
async function register(user) {
    try 
    {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(user)
        };

        const response = await fetch(process.env.REACT_APP_API_URL+`api/register`, requestOptions);

        if(user.signup_type === "google" || user.signup_type === "facebook"  ){
            const user = await handleResponse(response);
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            if(user.sucess === true){
                localStorage.setItem('user', JSON.stringify(user));
            }
            return user;
        }else{
            return handleResponse(response);      
        }    
    } 
    catch (error) 
    {
        return error;
    }

}

async function update(user) {
    delete user["email"];
    let formData = new FormData();
    // console.log("handleSubmit user update",user)
    Object.keys(user).forEach(fieldName => {
        if(fieldName === "villeArr"){
            formData.append(fieldName, JSON.stringify(user[fieldName]));
        }else{
            formData.append(fieldName, user[fieldName]);
        }
        
    });

     /* const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body:formData,   
    };

   const response = await fetch(process.env.REACT_APP_API_URL+`api/user/${user.id}`, requestOptions);    
    const user_data = await handleResponse(response); */
    const response = await axios.put(process.env.REACT_APP_API_URL+`api/user/${user.id}`, formData,authHeader());
    
    const user_data = response.data;
    // store user details and jwt token in local storage to keep user logged in between page refreshes
    
    if(localStorage.getItem('user')){
        let getData = JSON.parse(localStorage.getItem('user'));
        getData.data = user_data.data;
        localStorage.setItem('user', JSON.stringify(getData));
    }else{
        localStorage.setItem('user', JSON.stringify(user_data));
    }
    return user_data;
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    const response = await fetch(`/users/${id}`, requestOptions);
    return handleResponse(response);
}

async function forgot_password(email) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
    };

    const response = await fetch(process.env.REACT_APP_API_URL+`api/forgotpassword`, requestOptions);
    const user = await handleResponse(response);    
    return user;
}
async function userSession(userdata) {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}api/user/session/${userdata.token}`,
      {
        headers: { 
          'Authorization': `Bearer ${userdata.token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    const user = await handleResponse(response);

    if (user?.data?.isLogin === 0) {
      document.cookie = `authToken=; path=/; domain=${process.env.REACT_APP_SUB_DOMAIN}; expires=Thu, 01 Jan 1970 00:00:01 UTC; secure; SameSite=None`;
      logout();
      return { success: false, message: "Session expired" };
    }

    if (user?.sucess === true || user?.success === true) {
      // Get additional user details
      const userDetailsResponse = await axios.get(
        `${process.env.REACT_APP_API_URL}api/user/${user.data.id}`,
        {
          headers: { 
            'Authorization': `Bearer ${userdata.token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      const userDetails = await handleResponse(userDetailsResponse);
      const userData = {
        ...userDetails,
        success: true,
        sucess: true
      };

      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("userToken", userdata.token);
      localStorage.setItem("is_login", "true");
      return userData;
    }

    return { success: false, message: "Invalid session response" };
  } catch (error) {
    console.error("Session validation error:", error);
    if (error.response?.status === 401) {
      document.cookie = `authToken=; path=/; domain=${process.env.REACT_APP_SUB_DOMAIN}; expires=Thu, 01 Jan 1970 00:00:01 UTC; secure; SameSite=None`;
      logout();
    }
    return { success: false, message: error.response?.data?.message || "Session validation failed" };
  }
}
function handleResponse(response) {

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                // eslint-disable-next-line no-restricted-globals
                location.reload(true);
            }

            // Return the full error response object if available, otherwise create one
            if (data && (data.sucess !== undefined || data.success !== undefined)) {
                return data;
            }
            
            // For other errors (like 429), create a proper error response object
            return {
                sucess: false,
                msg: (data && (data.msg || data.message)) || response.statusText,
                data: []
            };
        }

        return data;
    });
}